import { RemoteConstants } from '../../data/remote/RemoteConstants';
import { PinesAction } from '../../presentation/redux/actions/PinesAction';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { errorManager } from '../../presentation/utils/errorManager';

/* eslint-disable no-unused-vars */
export const getHorarios = async (token, usuario, dispatch) => {
    try {
        const params = new URLSearchParams({
            token: token,
            uid: usuario
        });
        const peticion = await fetch(`${RemoteConstants.BASE_URL}pin/get-horarios?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(resp => {
                return resp.json();
            })
            .then(data => {
                if (data.code === 'OK') {
                    dispatch(PinesAction.getHorarios(data.data[0]));
                } else {
                    errorManager(data.userMessage);
                }
            });
    } catch (error) {
        errorManager(error);
    }
    dispatch(UIActions.uiLoadInactive());
}